import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const GLITCH_PARAMS = [
  {
    kind: 'int',
    key: 'slices',
    label: 'Slices',
    min: 1,
    max: 300,
    step: 1,
    scale: 'log',
    default: 26,
    bulkRange: [6, 90],
    group: 'Slices',
  },
  {
    kind: 'range',
    key: 'sliceHeight',
    label: 'Slice-Höhe',
    min: 1,
    max: 400,
    step: 1,
    default: [6, 60],
    unit: 'px',
    precision: 0,
    group: 'Slices',
  },
  {
    kind: 'float',
    key: 'shift',
    label: 'Max. Versatz',
    min: 0,
    max: 500,
    step: 1,
    default: 70,
    unit: 'px',
    bulkRange: [10, 220],
    group: 'Slices',
  },
  {
    kind: 'float',
    key: 'probability',
    label: 'Wahrscheinlichkeit',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0.65,
    group: 'Slices',
    tooltip: 'Anteil der Slices, die tatsächlich verschoben werden.',
  },
  {
    kind: 'int',
    key: 'repeat',
    label: 'Block-Wiederholung',
    min: 0,
    max: 6,
    step: 1,
    default: 1,
    group: 'Slices',
    tooltip: 'Wie oft ein verschobener Block zusätzlich kopiert wird.',
  },

  {
    kind: 'float',
    key: 'rgbSplit',
    label: 'RGB-Split',
    min: 0,
    max: 80,
    step: 0.5,
    default: 7,
    unit: 'px',
    bulkRange: [0, 30],
    group: 'Farbkanäle',
  },
  {
    kind: 'float',
    key: 'rgbAngle',
    label: 'Split-Winkel',
    min: -180,
    max: 180,
    step: 1,
    default: 0,
    unit: '°',
    group: 'Farbkanäle',
    showIf: (v) => (v.rgbSplit as number) > 0,
  },

  {
    kind: 'bool',
    key: 'pixelSort',
    label: 'Pixel Sorting',
    default: false,
    group: 'Sortierung',
    tooltip: 'Sortiert zusammenhängende helle Bereiche jeder Zeile nach Helligkeit.',
  },
  {
    kind: 'float',
    key: 'sortThreshold',
    label: 'Schwelle',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0.28,
    group: 'Sortierung',
    showIf: (v) => v.pixelSort === true,
  },
  {
    kind: 'enum',
    key: 'sortDirection',
    label: 'Richtung',
    default: 'horizontal',
    segmented: true,
    group: 'Sortierung',
    options: [
      { value: 'horizontal', label: 'Waagrecht' },
      { value: 'vertical', label: 'Senkrecht' },
    ],
    showIf: (v) => v.pixelSort === true,
  },

  {
    kind: 'float',
    key: 'blockNoise',
    label: 'Kompressionsartefakte',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0,
    group: 'Artefakte',
    tooltip: 'Quantisiert 8×8-Blöcke wie eine überfahrene JPEG-Datei.',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 1,
    group: 'Artefakte',
  },

  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'cyberpunk' },
    group: 'Farbe',
    tooltip: 'Der Text wird vor dem Glitchen aus dieser Palette eingefärbt.',
  },
  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Einfärbung',
    default: 'gradient',
    segmented: true,
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'gradient', label: 'Verlauf' },
    ],
  },
] as const satisfies ParamSchema;

export type GlitchValues = SchemaValues<typeof GLITCH_PARAMS>;
